export default __webpack_public_path__ + "static/media/onboarding_bg.849c5fe1.jpg";